import { h } from "@stencil/core";
import { LinkData, LinkTarget } from "./link-container";
import { LogService } from "../services";

/**
 * Creates a bbg-link element with the specified text (label), href (URL) and target
 * @param {string} linkText - Label that is displayed to the users
 * @param {string} linkHref - href attribute: The destination URL or path of the link
 * @param {string} linkTarget - target attribute of the link: Either _blank, _parent, _self or _top
 */
export const createHtmlLink = (linkText: string, linkHref?: string, linkTarget?: string) => {
	if (linkTarget == undefined) linkTarget = LinkTarget.SELF;

	const tempLink = (
		<bbg-link target={linkTarget} href={linkHref}>
			{linkText}
		</bbg-link>
	) as HTMLElement;

	LogService.log.trace("Temp Link:", tempLink);

	return tempLink;
};

/**
 * Replaces the specified text snippets with <bbg-link> elements.
 * @param {string} inputText - Text containing placeholders which shall be replaced by links
 * @param {LinkData[]} linkData - Array of linkData, containing name, linkUrl, linkLabel, linkTarget and linkPlaceholder
 * @returns {Array<HTMLElement|string>} - Array with strings and HTMLElements which can directly be passed as JSX to be rendered.
 * NOTE: If inputText starts or ends with placeholder, the result array will contain an empty string at the beginning/end!
 */
export const replaceHtmlLinks = (inputText: string, linkData: LinkData[]) => {
	// Split text with Regex (e.g. %ABC_XYZ% - capital letters and underscore). Capturing group (parantheses) leaves placeholders in resulting array, to be able to replace them later!
	const regex: RegExp = /(%[A-Z_]+%)/g;
	const textArray = inputText.split(regex);
	//console.log("Start replacing...");

	const htmlElementArray: (HTMLElement | string)[] = textArray.map(textPart => {
		if (regex.test(textPart)) {
			const placeholderLinkData = linkData.find(element => element.linkPlaceholder === textPart);
			//console.log("Placeholder:", textPart, "PlaceholderLinkData:", placeholderLinkData);

			if (placeholderLinkData) {
				return createHtmlLink(placeholderLinkData.linkLabel, placeholderLinkData.linkUrl, placeholderLinkData.linkTarget);
			} else {
				console.warn("No linkdata found for placeholder", textPart);
			}
		}

		return textPart;
	});

	//console.log("HTML element array:", htmlElementArray);

	return htmlElementArray;
};

// export const replaceHtmlLinks2 = (inputText: string, linkData: LinkData[]) => {
// 	const regex: RegExp = /%[A-Z_]+%/g;
// 	const htmlElementArray: HTMLElement | string[] = [];
//
// 	const foundPlaceholders = inputText.match(regex);
// 	console.log("Start replacing...");
//
// 	if (foundPlaceholders !== null) {
// 		console.log("Found placeholders:", foundPlaceholders);
// 		for (const placeholder of foundPlaceholders) {
// 			// Check if there is link data for the placeholder found in the text
// 			const placeholderLinkData = linkData.find(element => element.linkPlaceholder === placeholder);
// 			console.log("Placeholder:", placeholder, "PLD:", placeholderLinkData);
//
// 			if (placeholderLinkData) {
// 				const placeholderPosition = inputText.indexOf(placeholder);
// 				console.log("INDEX:", placeholderPosition);
// 				// Add text before placeholder and link, which is replacing placeholder to the HTML elements array
// 				htmlElementArray.push(
// 					inputText.slice(0, placeholderPosition),
// 					createHtmlLink(placeholderLinkData.linkLabel, placeholderLinkData.linkUrl, placeholderLinkData.linkTarget),
// 				);
// 				console.log("ARRAY:", htmlElementArray);
//
// 				// Remove placeholder and preceding text from input text
// 				inputText = inputText.slice(placeholderPosition + placeholder.length);
// 				console.log("Remaining Text:", inputText);
// 			} else {
// 				console.warn("No linkdata found for placeholder", placeholder);
// 			}
// 		}
// 	}
// 	// Add remaining of input text to array
// 	htmlElementArray.push(inputText);
//
// 	return htmlElementArray;
// };
